import { showError } from '@calendly/alert'
import { FormError, useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { useDispatch, useSelector } from 'react-redux'

import { Email2FAModal } from 'features/email_2fa_modal'
import { isMfaOpenSelector, isSubmittingSelector, mfaErrorSelector } from 'features/invite_flow/selectors'
import { clearMfaError, clearMfaVerificationGrant, closeMfa } from 'features/invite_flow/slice'


export const MfaModal = ({ onConfirm }) => {
  const dispatch = useDispatch()
  const isMfaOpen = useSelector(isMfaOpenSelector)
  const isSubmitting = useSelector(isSubmittingSelector)
  const error = useSelector(mfaErrorSelector)
  const { setErrors, values: { eventTypeIds, invitations, groupId } } = useFormContext()
  const onClose = () => {
    dispatch(clearMfaVerificationGrant())
    dispatch(closeMfa())
  }
  const onContinue = async ({ code }) => {
    try {
      const confirmed = await onConfirm({
        invitations,
        eventTypeIds,
        groupId,
        verificationCode: code
      })
      if (confirmed) onClose()
      return confirmed
    } catch (confirmationError) {
      if (confirmationError instanceof FormError) {
        setErrors(confirmationError.payload || {})
        onClose()
        return false
      }

      dispatch(showError(I18n.t('publisher.billing.failure.please_try_again')))
      return false
    }
  }

  const onErrorReset = () => dispatch(clearMfaError())

  if (!isMfaOpen) return null

  return (
    <Email2FAModal
      error={error}
      isSubmitting={isSubmitting}
      onClose={onClose}
      onContinue={onContinue}
      onErrorReset={onErrorReset}
    />
  )
}
